export default __webpack_public_path__ + "static/media/pop.69b53c30.mp3";